// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("./MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.res.js");
var MM_proof_tree_dto = require("./MM_proof_tree_dto.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");

function extractVarToRecIdxMapping(args, frame) {
  var varToRecIdxMapping = new Array(frame.numOfVars);
  var locks = Belt_Array.make(frame.numOfVars, false);
  if (args.length !== frame.numOfArgs) {
    return {
            TAG: "Error",
            _0: "extractVarToRecIdxMapping: args.Array.length != frame.numOfArgs"
          };
  }
  var err = {
    contents: undefined
  };
  frame.hyps.forEach(function (hyp, i) {
        if (!(Belt_Option.isNone(err.contents) && hyp.typ === "F")) {
          return ;
        }
        var v = hyp.expr[1];
        if (locks[v]) {
          err.contents = {
            TAG: "Error",
            _0: "extractVarToRecIdxMapping: locks[v]"
          };
        } else {
          locks[v] = true;
          varToRecIdxMapping[v] = args[i];
        }
      });
  var err$1 = err.contents;
  if (err$1 !== undefined) {
    return err$1;
  } else if (locks.some(function (lock) {
          return !lock;
        })) {
    return {
            TAG: "Error",
            _0: "extractVarToRecIdxMapping: locks->Array.some(lock => !lock)"
          };
  } else {
    return {
            TAG: "Ok",
            _0: varToRecIdxMapping
          };
  }
}

function getHeight(ch) {
  if (ch.TAG === "Subtree") {
    return ch._0.height;
  } else {
    return 0;
  }
}

function getMaxHeight(children) {
  return Core__Array.reduce(children, 0, (function (max, ch) {
                return Math.max(max, getHeight(ch));
              }));
}

function buildSyntaxTreeInner(idSeq, ctx, tbl, r) {
  var match = r.proof;
  if (match.TAG === "Hypothesis") {
    var label = match.label;
    var maxI = r.expr.length - 1 | 0;
    var this_id = idSeq();
    var this_typ = r.expr[0];
    var this_children = new Array(maxI);
    for(var i = 1; i <= maxI; ++i){
      this_children[i - 1 | 0] = {
        TAG: "Symbol",
        id: idSeq(),
        symInt: r.expr[i],
        sym: MM_context.ctxIntToSymExn(ctx, r.expr[i]),
        color: undefined,
        isVar: r.expr[i] >= 0
      };
    }
    return {
            TAG: "Ok",
            _0: {
              id: this_id,
              typ: this_typ,
              label: label,
              children: this_children,
              height: getMaxHeight(this_children) + 1 | 0
            }
          };
  }
  var label$1 = match.label;
  var frame = MM_context.getFrame(ctx, label$1);
  if (frame === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot find a frame by label '" + label$1 + "' in buildSyntaxTreeInner."
          };
  }
  var msg = extractVarToRecIdxMapping(match.args, frame);
  if (msg.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
  var varToRecIdxMapping = msg._0;
  var this_id$1 = idSeq();
  var this_typ$1 = frame.asrt[0];
  var this_children$1 = new Array(frame.asrt.length - 1 | 0);
  var err = {
    contents: undefined
  };
  frame.asrt.forEach(function (s, i) {
        if (!(i > 0 && Belt_Option.isNone(err.contents))) {
          return ;
        }
        if (s < 0) {
          this_children$1[i - 1 | 0] = {
            TAG: "Symbol",
            id: idSeq(),
            symInt: s,
            sym: MM_context.ctxIntToSymExn(ctx, s),
            color: undefined,
            isVar: false
          };
          return ;
        }
        var msg = buildSyntaxTreeInner(idSeq, ctx, tbl, tbl[varToRecIdxMapping[s]]);
        if (msg.TAG !== "Ok") {
          err.contents = {
            TAG: "Error",
            _0: msg._0
          };
          return ;
        }
        this_children$1[i - 1 | 0] = {
          TAG: "Subtree",
          _0: msg._0
        };
      });
  var err$1 = err.contents;
  if (err$1 !== undefined) {
    return err$1;
  } else {
    return {
            TAG: "Ok",
            _0: {
              id: this_id$1,
              typ: this_typ$1,
              label: label$1,
              children: this_children$1,
              height: getMaxHeight(this_children$1) + 1 | 0
            }
          };
  }
}

function buildSyntaxTree(ctx, tbl, targetIdx) {
  var nextId = {
    contents: 0
  };
  var idSeq = function () {
    nextId.contents = nextId.contents + 1 | 0;
    return nextId.contents - 1 | 0;
  };
  return buildSyntaxTreeInner(idSeq, ctx, tbl, tbl[targetIdx]);
}

function syntaxTreeToSymbols(node) {
  return Belt_Array.concatMany(node.children.map(function (childNode) {
                  if (childNode.TAG === "Subtree") {
                    return syntaxTreeToSymbols(childNode._0);
                  } else {
                    return [childNode.sym];
                  }
                }));
}

function syntaxTreeIsEmpty(node) {
  return node.children.length === 0;
}

function getNodeById(tree, childId) {
  return Expln_utils_data.traverseTree(undefined, {
                TAG: "Subtree",
                _0: tree
              }, (function (param, node) {
                  if (node.TAG === "Subtree") {
                    return node._0.children;
                  }
                  
                }), undefined, (function (param, node) {
                  var id;
                  id = node.TAG === "Subtree" ? node._0.id : node.id;
                  if (id === childId) {
                    return node;
                  }
                  
                }), undefined)[1];
}

function buildSyntaxProofTableFromProofTreeDto(ctx, proofTreeDto, typeStmt) {
  var proofNode = proofTreeDto.nodes.find(function (node) {
        return MM_context.exprEq(node.expr, typeStmt);
      });
  if (proofNode !== undefined) {
    return {
            TAG: "Ok",
            _0: MM_proof_tree_dto.createProofTable(proofTreeDto, proofNode, undefined, undefined)
          };
  } else {
    return {
            TAG: "Error",
            _0: "buildSyntaxProofTableFromProofTreeDto: could not find a proof for: " + MM_context.ctxIntsToStrExn(ctx, typeStmt)
          };
  }
}

function buildSyntaxTreeFromProofTreeDto(ctx, proofTreeDto, typeStmt) {
  var msg = buildSyntaxProofTableFromProofTreeDto(ctx, proofTreeDto, typeStmt);
  if (msg.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
  var proofTable = msg._0;
  return buildSyntaxTree(ctx, proofTable, proofTable.length - 1 | 0);
}

function isVar(expr, isMetavar) {
  var match = expr.children.length;
  if (match !== 1) {
    return ;
  }
  var match$1 = expr.children[0];
  if (match$1.TAG === "Subtree") {
    return ;
  }
  var sym = match$1.sym;
  if (match$1.isVar && isMetavar(sym)) {
    return [
            match$1.symInt,
            sym
          ];
  }
  
}

function applySubsInPlace(expr, subs) {
  Belt_HashMapString.forEach(subs, (function (v, subExpr) {
          var i = 0;
          while(i < expr.length) {
            if (expr[i] === v) {
              Caml_splice_call.spliceObjApply(expr, "splice", [
                    i,
                    1,
                    subExpr
                  ]);
              i = i + subExpr.length | 0;
            } else {
              i = i + 1 | 0;
            }
          };
        }));
}

function assignSubs(foundSubs, $$var, expr) {
  applySubsInPlace(expr, foundSubs);
  if (expr.includes($$var)) {
    return false;
  }
  var existingExpr = Belt_HashMapString.get(foundSubs, $$var);
  if (existingExpr !== undefined) {
    return Caml_obj.equal(expr, existingExpr);
  } else {
    Belt_HashMapString.set(foundSubs, $$var, expr);
    Belt_HashMapString.forEach(foundSubs, (function (param, expr) {
            applySubsInPlace(expr, foundSubs);
          }));
    return true;
  }
}

function getAllSymbols(syntaxTreeNode) {
  return Expln_utils_common.arrFlatMap(syntaxTreeNode.children, (function (ch) {
                if (ch.TAG === "Subtree") {
                  return getAllSymbols(ch._0);
                } else {
                  return [ch.sym];
                }
              }));
}

function eqModSubs(subs, a, b) {
  var expr1 = [a];
  applySubsInPlace(expr1, subs);
  var expr2 = [b];
  applySubsInPlace(expr2, subs);
  return Caml_obj.equal(expr1, expr2);
}

function unify(a, b, isMetavar, foundSubs, $$continue) {
  var match = isVar(a, isMetavar);
  if (match !== undefined) {
    var aVar = match[1];
    var match$1 = isVar(b, isMetavar);
    if (match$1 === undefined) {
      $$continue.contents = assignSubs(foundSubs, aVar, getAllSymbols(b));
      return ;
    }
    var bVar = match$1[1];
    $$continue.contents = eqModSubs(foundSubs, aVar, bVar) || assignSubs(foundSubs, aVar, [bVar]);
    return ;
  }
  var match$2 = isVar(b, isMetavar);
  if (match$2 !== undefined) {
    $$continue.contents = assignSubs(foundSubs, match$2[1], getAllSymbols(a));
    return ;
  }
  if (a.children.length !== b.children.length) {
    $$continue.contents = false;
    return ;
  }
  var maxI = a.children.length - 1 | 0;
  var i = 0;
  while($$continue.contents && i <= maxI) {
    var aCh = a.children[i];
    if (aCh.TAG === "Subtree") {
      var aCh$1 = aCh._0;
      var bCh = b.children[i];
      if (bCh.TAG === "Subtree") {
        unify(aCh$1, bCh._0, isMetavar, foundSubs, $$continue);
      } else {
        var bSym = bCh.sym;
        $$continue.contents = bCh.isVar && isMetavar(bSym) && assignSubs(foundSubs, bSym, getAllSymbols(aCh$1));
      }
    } else {
      var aIsVar = aCh.isVar;
      var aSym = aCh.sym;
      var bCh$1 = b.children[i];
      if (bCh$1.TAG === "Subtree") {
        $$continue.contents = aIsVar && isMetavar(aSym) && assignSubs(foundSubs, aSym, getAllSymbols(bCh$1._0));
      } else {
        var bSym$1 = bCh$1.sym;
        $$continue.contents = eqModSubs(foundSubs, aSym, bSym$1) || aIsVar && isMetavar(aSym) && assignSubs(foundSubs, aSym, [bSym$1]) || bCh$1.isVar && isMetavar(bSym$1) && assignSubs(foundSubs, bSym$1, [aSym]);
      }
    }
    i = i + 1 | 0;
  };
}

function syntaxTreeForEachNode(tree, consumer) {
  return Expln_utils_data.traverseTree(undefined, tree, (function (param, node) {
                  if (node.TAG === "Subtree") {
                    return node._0.children;
                  }
                  
                }), undefined, (function (param, node) {
                  return consumer(node);
                }), undefined)[1];
}

function syntaxTreeGetIdsOfAllChildSymbols(tree) {
  var res = [];
  syntaxTreeForEachNode(tree, (function (node) {
          if (node.TAG !== "Subtree") {
            res.push(node.id);
          }
          
        }));
  return Belt_SetInt.fromArray(res);
}

function syntaxTreeToText(node) {
  var res = [];
  syntaxTreeForEachNode(node, (function (node) {
          if (node.TAG !== "Subtree") {
            res.push(node.sym);
          }
          
        }));
  return res.join(" ");
}

function syntaxTreeGetNumberOfSymbols(node) {
  var cnt = {
    contents: 0
  };
  syntaxTreeForEachNode(node, (function (node) {
          if (node.TAG !== "Subtree") {
            cnt.contents = cnt.contents + 1 | 0;
          }
          
        }));
  return cnt.contents;
}

function syntaxTreeGetParent(root, childId) {
  return Core__Array.reduce(root.children, undefined, (function (res, ch) {
                if (res !== undefined) {
                  return res;
                }
                if (ch.TAG !== "Subtree") {
                  if (ch.id === childId) {
                    return root;
                  } else {
                    return ;
                  }
                }
                var subRoot = ch._0;
                if (subRoot.id === childId) {
                  return root;
                } else {
                  return syntaxTreeGetParent(subRoot, childId);
                }
              }));
}

exports.buildSyntaxTree = buildSyntaxTree;
exports.buildSyntaxProofTableFromProofTreeDto = buildSyntaxProofTableFromProofTreeDto;
exports.buildSyntaxTreeFromProofTreeDto = buildSyntaxTreeFromProofTreeDto;
exports.syntaxTreeToSymbols = syntaxTreeToSymbols;
exports.syntaxTreeIsEmpty = syntaxTreeIsEmpty;
exports.getNodeById = getNodeById;
exports.syntaxTreeForEachNode = syntaxTreeForEachNode;
exports.syntaxTreeGetIdsOfAllChildSymbols = syntaxTreeGetIdsOfAllChildSymbols;
exports.syntaxTreeToText = syntaxTreeToText;
exports.syntaxTreeGetNumberOfSymbols = syntaxTreeGetNumberOfSymbols;
exports.syntaxTreeGetParent = syntaxTreeGetParent;
exports.isVar = isVar;
exports.unify = unify;
/* MM_context Not a pure module */
